import { FC, ReactNode } from 'react';

import { Center, rem } from '@bonusly/design-system';

interface LoadingViewProps {
	children: ReactNode;
}

export const LoadingView: FC<LoadingViewProps> = (props) => <Center data-testid="app-loading" h={`calc(100vh - ${rem(64)})`} {...props} />;
